import type { ReactNode } from "react";
import { permissionPhrase } from "../lib/permissions";

/**
 * ADR-0017 section 5, the UI half of RBAC at both ends: a control inside a
 * section the person can see, but whose verb they do not hold, is disabled
 * and says which permission it wanted. A whole section they cannot see is
 * hidden instead, never explained.
 */
export function NotHeld({ permission, className = "" }: { permission: string; className?: string }) {
  return (
    <span role="note" className={`text-xs text-neutral-500 dark:text-neutral-400 ${className}`}>
      You do not hold {permissionPhrase(permission)} here.
    </span>
  );
}

/** A form whose every control is disabled when the verb is missing, with the reason above it. */
export function Locked({ permission, allowed, children, className = "" }: { permission: string; allowed: boolean; children: ReactNode; className?: string }) {
  if (allowed) return <>{children}</>;
  return (
    <div className={className}>
      <NotHeld permission={permission} className="mb-2 block" />
      {/* Pointer events off too: a drag bar is not a form control and would otherwise reach the API, which refuses it. */}
      <fieldset disabled className="pointer-events-none min-w-0 opacity-70">
        {children}
      </fieldset>
    </div>
  );
}
